import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import myAvailabilityServices from 'src/services/apiServices/my-availability-services/my-availability-services';

const {
  GET_MY_AVAILABILITY_REQUEST,
  GET_MY_AVAILABILITY_SUCCESS,
  GET_MY_AVAILABILITY_FAILURE,
  GET_MY_AVAILABILITY_LOADING,
} = getMyAvailabilityConstants;

function* getMyAvailability(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MY_AVAILABILITY_LOADING });
    const response = yield call(myAvailabilityServices.getMyAvailability, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_MY_AVAILABILITY_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MY_AVAILABILITY_FAILURE, payload: error });
  }
}

function* getMyAvailabilitySaga() {
  yield takeEvery(GET_MY_AVAILABILITY_REQUEST, getMyAvailability);
}

export default getMyAvailabilitySaga;
